import Vue from 'vue'
import Vuex from 'vuex'
import state from '@/store/state';
import actions from '@/store/actions';
import mutations from '@/store/mutations';
import getters from '@/store/getters';
import VuexPersist from 'vuex-persist';
import config from '@/config';

/** Se necesita el session storage para hacer tracking con el plugin de adobe */
const vuexPersist = new VuexPersist({
  key: config.storage.key,
  storage: sessionStorage
})

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state,
  getters,
  mutations,
  actions,
})